import { FileNode, FolderNode } from '@editor/interfaces'
import { fileStore } from '@editor/state'

export const useFileNode = (id: string): FileNode | FolderNode | undefined => {
  return fileStore.folders[id] || fileStore.files[id]
}
